import { useTooltip } from '../../';
import { Dot, type ColoredDotProps } from '../dot.component';

export const NeutralDot = ({ hoverText, children, ...props }: ColoredDotProps) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({ placement: 'top' });
  const { ref, ...rest } = triggerProps;

  return (
    <Dot color='neutral' {...props} {...rest} innerRef={ref}>
      {children}
      {hoverText && <Tooltip {...tooltipProps}>{hoverText}</Tooltip>}
    </Dot>
  );
};
